export default __webpack_public_path__ + "static/media/ambimoney.a2c73eb3.md";